import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NavLeftComponent } from '@shared/nav-left/nav-left.component';


@NgModule({
  declarations: [NavLeftComponent],
  exports: [NavLeftComponent],
  imports: [CommonModule, RouterModule]
})
export class NavLeftModule {}
